import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { ErrorBoundary } from '@/app/ErrorBoundary'
import { Providers } from '@/app/providers'
import { AppRoutes } from '@/app/router'
import { I18nProvider, applyDocumentLocale, detectLocale, loadMessages } from '@/i18n'

import { initInstallPrompt } from '@/lib/install'
import { applyTheme, readThemePreference, watchSystemTheme } from '@/lib/theme'

import './index.css'

// index.html 已经挂过一次主题，这里补上「跟随系统」时的实时切换
applyTheme(readThemePreference())
watchSystemTheme(() => {
  if (readThemePreference() === 'system') applyTheme('system')
})

// 浏览器的安装事件只发一次，常常在打开设置页之前：启动时就接住（Phase 3d）
initInstallPrompt()

const container = document.getElementById('root')
if (!container) throw new Error('找不到 #root 挂载点')

// 先把语言定下来、词典拿到手，再挂载：否则英文 / 日文用户会先看到一帧中文。
// 用 .then 而不是顶层 await —— 不依赖构建目标是否允许 TLA。
const locale = detectLocale()
applyDocumentLocale(locale)

void loadMessages(locale).then((messages) => {
  createRoot(container).render(
    <StrictMode>
      <I18nProvider locale={locale} messages={messages}>
        <ErrorBoundary>
          <BrowserRouter>
            <Providers>
              <AppRoutes />
            </Providers>
          </BrowserRouter>
        </ErrorBoundary>
      </I18nProvider>
    </StrictMode>,
  )
})
